import httpStore from "@/api/httpStore.js";

export function getEbayCategories(search) {
  return httpStore
    .get(`/ebay_categories?search=${search}`)
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}
export function getEbayCategoryProducts(filters) {
  return httpStore
    .get("/ebay_categories/products", { params: filters })
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

export function addEbayCategoryToProduct(unificado, categoryId) {
  return httpStore
    .post(`ebay_categories/category`, {
      unificado: unificado,
      categoryId: categoryId
    })
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}
